import React, { useEffect } from 'react';
import PublicLayout from '../templates/PublicLayout';
import 'tailwindcss/tailwind.css';

const DeleteAccountInfo = () => {

   
  return (
    <PublicLayout>
      <div className="p-8 font-sans h-screen leading-relaxed text-black">
        <h1 className="text-4xl mb-8 border-b-2 border-cyan-500 pb-2">Como Excluir Sua Conta</h1>

        <div className="mb-8">
          <h2 className="text-3xl mb-4">Informações Gerais</h2>
          <p className="text-lg">
            Para excluir sua conta no FonotherApp, você precisa estar logado no sistema. Depois, vá até o painel no canto superior direito e escolha a opção <strong>Excluir a conta</strong>.
          </p>
        </div>

        <div>
          <h2 className="text-3xl mb-4">Passos Detalhados</h2>
          <ol className="list-decimal ml-5 mb-5 text-lg">
            <li className="mb-2">Faça login no site do FonotherApp.</li>
            <li className="mb-2">Acesse o painel no canto superior direito.</li>
            <li className="mb-2">Selecione a opção <strong>Excluir a conta</strong>.</li>
            <li className="mb-2">Siga as instruções para confirmar a exclusão da conta.</li>
          </ol>
        </div>
      </div>
    </PublicLayout>
  );
};

export default DeleteAccountInfo;
